module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('carousel-page', {
    attrs: {
      "type": 4
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2",
    attrs: {
      "id": "yanxuejiaoxu"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.yxList), function(item, index) {
    return _c('div', {
      class: index < 2 ? 'col-lg-6' : 'col-lg-4',
      staticStyle: {
        "margin-bottom": "20px"
      },
      attrs: {
        "index": index
      }
    }, [_c('div', {
      staticClass: "yxItem"
    }, [_c('div', {
      staticClass: "mb-3"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.titleImage,
        "alt": item.subTitle
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "yxItemTextT"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "yxItemTextST"
    }, [_vm._v(_vm._s(item.subTitle))]), _vm._v(" "), _c('p', {
      staticClass: "yxItemText"
    }, [_vm._v(_vm._s(item.content))])])])
  }), 0)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2",
    attrs: {
      "id": "jiaguwen"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, _vm._l((_vm.jgwList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-4 pRelative",
      staticStyle: {
        "margin-bottom": "20px",
        "cursor": "pointer"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.titleImage,
        "alt": item.title
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "featureShuwInfo"
    }, [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "SbgWarp"
  }, [_c('div', {
    staticClass: "bgtextTitle"
  }, [_vm._v("特色业务")]), _vm._v(" "), _c('div', {
    staticClass: "fbgTextWarp"
  }, [_c('div', {
    class: _vm.cutFbgTextIndex == 0 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(0)
      }
    }
  }, [_vm._v("研学教育")]), _vm._v(" "), _c('div', {
    class: _vm.cutFbgTextIndex == 1 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(1)
      }
    }
  }, [_vm._v("跨境旅游")]), _vm._v(" "), _c('div', {
    class: _vm.cutFbgTextIndex == 2 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(2)
      }
    }
  }, [_vm._v("甲骨文书屋")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderBCD"
  }, [_vm._v("研学教育")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow"
  }, [_vm._v("RESEARCH EDUCATION")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-area section-padding2",
    attrs: {
      "id": "kuajinglvyou"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "static/assets/images/feature/06.png",
      "alt": "企业介绍"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderBCD"
  }, [_vm._v("甲骨文书屋")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow"
  }, [_vm._v("JIAGUWEN LIBRARY")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb6d22e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Feature.vue
// module id = 105
// module chunks = 1